import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import DashboardLayout from '../../components/templates/DashboardLayout/DashboardLayout'
import './dashboard.css'
import CheckBox from '../../components/atoms/CheckBox'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import { request } from '../../Utils/Request'
import { apiEndPoint } from '../../Utils/Redux/Store/apiEndpoint'
import { check } from 'prettier'
import { isAuthenticated, userRole } from '../../Utils/Auth'
import JwtDecode from 'jwt-decode'
import CustomInput from '../../components/atoms/Inputs/CustomInput'
import CustomSelect from '../../components/atoms/Inputs/CustomSelect'
import { useSnackbar } from 'notistack'
import { handleRedirectInternal } from '../../common/components'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@material-ui/core'

import './mylots.css'
import * as axios from 'axios'
const MyLots = () => {
    const { t } = useTranslation()
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [filterData, setFilterData] = useState('')
    const [msgPopup, setMsgPopup] = useState(false)
    const [modalMessage, setModalMessage] = useState('')
    const [notify, setNotify] = useState(0)
    const [projectId, setProjectId] = useState(0)
    const history = useHistory()
    const location = useLocation()
    const [user, setUser] = React.useState(
        localStorage.getItem('coachUser') ? JSON.parse(localStorage.getItem('coachUser')) : {},
    )
    // const data = [
    //     {
    //         id: 12122,
    //         regNumber: 'NKL21U',
    //         mileage: '21,121',
    //         price: '223,811',
    //         status: 'Moderate',
    //         actions: ['Send for admin approval'],
    //     },
    //     {
    //         id: 32441,
    //         regNumber: 'ABC12D',
    //         mileage: '12,233',
    //         price: '156,211',
    //         status: 'Draft',
    //         actions: [],
    //     },
    //     {
    //         id: 45678,
    //         regNumber: 'DEF34G',
    //         mileage: '10,001',
    //         price: '296,211',
    //         status: 'Draft',
    //         actions: [],
    //     },
    // ]

    let archived = 0
    const isAutoLogin = localStorage.getItem('autoLogin') == 1
    const [selectedLots, setSelectedLots] = useState([])
    const [lots, setLots] = useState([])
    const queryParams = new URLSearchParams(location.search)
    archived = queryParams.get('archived')

    useEffect(() => {
        getSellerProducts()
    }, [archived])

    const handleCheckboxChange = (id) => {
        setSelectedLots((prev) =>
            prev.includes(id) ? prev.filter((lotId) => lotId !== id) : [...prev, id],
        )
    }

    const handleMoveToArchive = async () => {
        console.log('Moving to archive:', selectedLots)

        const { data } = await request(
            'post',
            `/carzaar/moveArchive`,
            {
                projectIds: selectedLots,
            },
            true,
            1,
        )

        if (data?.success == true) {
            getSellerProducts()
            enqueueSnackbar(data?.message, {
                variant: 'success',
            })
        } else {
            if (data?.message) {
                enqueueSnackbar(data?.message, {
                    variant: 'error',
                })
            } else {
                enqueueSnackbar('Something went wrong', {
                    variant: 'error',
                })
            }
        }
    }

    const sendLotForAdminApproval = async (lot) => {
        try {
            const data = {
                vehicleName: '',
                regNum: lot.regNum,
                mileage: lot.mileage,
                keys: lot.keys,
                tyres: lot.tyres,
                year: lot.year,
                month: lot.month,
                leasingValue: lot.leasingValue,
                financeValue: lot.financeValue,
                paidOff: lot.paidOff,
                specificDetails: lot.specificDetails,
                damageNotes: lot.damageNotes,
                price: lot.price,
                site_id: process.env.REACT_APP_SITE_ID,
                product_images:
                    formik.values.vehicle_interior.length > 0 ? formik.values.vehicle_interior : [],
                market_status: 'draft',
            }

            const formData = new FormData()
            for (const [key, value] of Object.entries(data)) {
                formData.set(key, value)
            }

            const res = await request('post', `/sellerupdateproject_carzaar`, formData, true)

            if (res.data.success) {
                enqueueSnackbar('Listing Updated Successfully', {
                    variant: 'success',
                })
                handleRedirectInternal(history, 'dashboard/seller/mylots')
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getSellerProducts = async (status) => {
        try {
            let data = {
                limit: 10,
                page: 1,
                status: status ? status : '',
                role: user?.role,
            }
            if (archived) {
                data.archive = 1
            }

            const res = await request('post', apiEndPoint.getSellerProducts, data, true)

            if (res.data.status == 'yes') {
                setLots(res.data.data.result)
            } else {
                setLots([])
            }
        } catch (error) {
            console.log(error)
        }
    }
    const handleFilterChange = (status) => {
        setFilterData(status)
        getSellerProducts(status)
    }

    const handleModalViewMessage = (message, id, startNotify) => {
        setMsgPopup(true)
        setModalMessage(message)
        setNotify(startNotify)
        setProjectId(id)
    }

    const handleUpdateMsgStatus = (status) => {
        const body = {
            id: projectId,
            status: status,
            site_id: process.env.REACT_APP_SITE_ID,
        }

        axios
            .post(`${process.env.REACT_APP_BASE_URL}/mobileapi/updateNotesStatus`, body)
            .then((response) => {
                if (response?.data?.success) {
                    enqueueSnackbar('Updated successfully!', { variant: 'success' })
                    setMsgPopup(false)
                    getSellerProducts()
                } else {
                    enqueueSnackbar('Update failed. Please try again.', { variant: 'failed' })
                    setMsgPopup(false)
                    getSellerProducts()
                }
            })
            .catch((error) => {
                console.error('Error - Update msg status', error)
                enqueueSnackbar('Update failed. Please try again.', { variant: 'failed' })
                setMsgPopup(false)
                getSellerProducts()
            })
    }

    return (
        <DashboardLayout>
            <div className="titleContainer">
                <h3 className="mb-0">{t('my_lots')}</h3>
                {/* <div className="backbtn">
                    <span className="material-icons">keyboard_backspace</span>
                    {t('back')}
                </div> */}
            </div>
            <div className="notification-table my-lots-table mt-3">
                <div className="tableFilters">
                    <CustomInput
                        placeholder={`${t('search_auctions')}...`}
                        name="search"
                        labelClass="labelSearch"
                        inputClassName="searchbar"
                        endAdornment={
                            <span className="material-icons searchbar-button">search</span>
                        }
                    />
                    <div className="selectFil">
                        <CustomSelect
                            floatLabel={t('result_per_page')}
                            labelClass={'text-left'}
                            selectClassName={'search-filter-year'}
                            name="limit"
                            shrink={true}
                            // value={filterData.transmission}
                            // onChange={(e) => handleFilterChange(e)}
                        >
                            <option value="1">12 {t('per_page')}</option>
                            <option value="2">20 {t('per_page')}</option>
                        </CustomSelect>
                        <CustomSelect
                            floatLabel={'Status'}
                            labelClass={'text-left'}
                            selectClassName={'search-filter-year'}
                            name="status"
                            value={filterData}
                            shrink={true}
                            onChange={(e) => handleFilterChange(e.target.value)}
                        >
                            <option value="">{t('all')}</option>
                            <option value="draft">{t('pending')}</option>
                            <option value="open">{t('approved')}</option>
                            {/* {transmissionType.map((el) => (
                            <option key={el.id} value={el.id}>
                                {el.type}
                            </option>
                        ))} */}
                        </CustomSelect>
                    </div>
                </div>
                <div className="table-responsive">
                    {selectedLots.length > 0 && (
                        <div className="archive_container">
                            <PrimaryButton
                                label={'Move to archive'}
                                onClick={handleMoveToArchive}
                            />
                        </div>
                    )}
                    <table className="table custom-table buyer-notification mt-2 mb-0">
                        <thead>
                            <tr>
                                {isAutoLogin && userRole() == 4 && <th className="p-2">Select</th>}
                                <th className="p-2">{t('id')}#</th>
                                <th className="p-2">{t('registration_number')}</th>
                                <th className="p-2">{t('mileage')}</th>
                                <th className="p-2">{t('expected_price')}</th>
                                <th className="p-2">Status</th>
                                {user?.role == 1 && <th className="p-2">{t('message')}</th>}
                                {/* <th className="p-2">Action</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {lots?.length > 0
                                ? lots.map((item, index) => (
                                      <tr key={item.id} className="border-b">
                                          {isAutoLogin && userRole() == 4 && (
                                              <td>
                                                  <input
                                                      type="checkbox"
                                                      checked={selectedLots.includes(item.id)}
                                                      onChange={() => handleCheckboxChange(item.id)}
                                                  />
                                              </td>
                                          )}
                                          <td className="p-2">{item.id}</td>
                                          <td className="p-2">{item.modelnumber}</td>
                                          <td className="p-2">{item.custom_field_4}</td>
                                          <td className="p-2">{item.wprice}</td>
                                          <td className="p-2">
                                              {item.market_status == 'moderate'
                                                  ? 'Draft'
                                                  : item.market_status == 'draft'
                                                  ? t('pending_admin')
                                                  : item.market_status == 'open'
                                                  ? t('in_auction')
                                                  : item.market_status == 'sold'
                                                  ? t('sold_status')
                                                  : item.market_status}
                                          </td>
                                          {user?.role == 1 && (
                                              <td className="p-2">
                                                  {item?.custom_field_7 ? (
                                                      <Button
                                                          onClick={() =>
                                                              handleModalViewMessage(
                                                                  item?.custom_field_7,
                                                                  item?.id,
                                                                  item?.start_notify,
                                                              )
                                                          }
                                                      >
                                                          View
                                                      </Button>
                                                  ) : (
                                                      '--'
                                                  )}
                                              </td>
                                          )}
                                          <td className="p-2 d-flex" style={{ gap: '10px' }}>
                                              {/* {item.actions.map((action, i) => (
                                                  <PrimaryButton
                                                      customClassName="buttonsAcc"
                                                      key={i}
                                                  >
                                                      {action}
                                                  </PrimaryButton>
                                              ))} */}
                                          </td>
                                      </tr>
                                  ))
                                : null}
                        </tbody>
                    </table>
                    {msgPopup && (
                        <div className="modal">
                            <div className="modal-content">
                                <span className="close-btn" onClick={() => setMsgPopup(false)}>
                                    &times;
                                </span>
                                <h2>Admin Message</h2>
                                <p>{modalMessage}</p>
                                {notify == 1 || notify == 0 ? (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            gap: '20px',
                                        }}
                                    >
                                        <button
                                            style={{
                                                backgroundColor: '#28a745',
                                                color: '#FFFFFF',
                                                border: 'none',
                                            }}
                                            onClick={() => handleUpdateMsgStatus(2)}
                                        >
                                            Accept
                                        </button>
                                        <button
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: '#FFFFFF',
                                                border: 'none',
                                            }}
                                            onClick={() => handleUpdateMsgStatus(3)}
                                        >
                                            Reject
                                        </button>
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            gap: '20px',
                                        }}
                                    >
                                        <button
                                            style={{
                                                backgroundColor: '#28a745',
                                                color: '#FFFFFF',
                                                border: 'none',
                                            }}
                                        >
                                            Accepted
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </DashboardLayout>
    )
}

export default MyLots
